const dollars = num => {
  num = parseFloat(num).toFixed(2);
  return `$${num}`;
};

import randomcolor from "randomcolor";
const generateColors = (num, alpha = false) => {
  let colors = [];
  let base = [
    "#BC0024",
    "#d66a47",
    "#e3c492",
    "#5a447a",
    "#88a877",
    "#56909b",
    "#2a5476",
    "#920722",
    "#EC6868",
    "#ffaaaa",
    "#423b3b"
  ];

  if (num > base.length) {
    colors = base;
    let gen = num - base.length;
    let i = 1;
    let j = 0;
    while (i <= gen) {
      j = i - 1;
      if (i > base.length) j = i - base.length - 1;
      colors.push(randomcolor({ hue: base[j] }));
      i++;
    }
  } else if (num == base.length) {
    colors = base;
  } else {
    colors = base.slice(0, num);
  }

  if (alpha) {
    let newColors = [];
    colors.map(function(item) {
      newColors.push(item + alpha);
    });
    colors = newColors;
  }

  return colors;
};

export { dollars, generateColors };

export default {
  dollars,
  generateColors
};
